module.exports = {
	"title": "Navigation Title",
	"aboutInfo": {
		"title": "About",
		"weAre": "Martian is a creative development studio in San&nbsp;Francisco.",
		"phone": "415.309.9362",
		"email": "hello@martiansf.com"
	},
	"navColumns": [
		{
			"title": "Work",
			"className": "nav-col-ul",
			"listlinks": [
				{
					"title": "Twitter Marketing",
					"url": "/work/twitter-marketing"
				},
				{
					"title": "Twitter Flight School",
					"url": "/work/twitter-flight-school"
				},
				{
					"title": "Airbnb: Maisons de France",
					"url": "/work/airbnb-maisons-de-france"
				},
				{
					"title": "Airbnb: Road Trips",
					"url": "/work/airbnb-road-trips"
				},
				{
					"title": "Airbnb: Holidays App",
					"url": "/work/airbnb-holidays-app"
				},
				{
					"title": "Sony: HMZ",
					"url": "/work/sony-hmz"
				},
				{
					"title": "Merrill: Infographics",
					"url": "/work/merrill-infographics"
				},
				{
					"title": "Eventbrite Prototype",
					"url": "/work/eventbrite-prototype"
				},
				{
					"title": "Thinknear",
					"url": "/work/thinknear"
				},
				{
					"title": "Mede Analytics",
					"url": "/work/mede-analytics"
				},
				{
					"title": "Twitter: Videohub",
					"url": "/work/twitter-videohub"
				}
			]
		},
		{
			"title": "Labs",
			"className": "nav-col-ul",
			"listlinks": [
				{
					"title": "Metagramme",
					"url": "/labs/metagramme"
				},
				{
					"title": "Twitter Fingerprint",
					"url": "/labs/twitter-fingerprint"
				},
				{
					"title": "Scrum Poker",
					"url": "/labs/scrum-poker"
				},
				{
					"title": "MoonPhase",
					"url": "/labs/moonphase"
				},
				{
					"title": "Serenade",
					"url": "/labs/serenade"
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/data/nav.json
 ** module id = 95
 ** module chunks = 0
 **/